import { Address } from '@thirdweb-dev/sdk';
import { useContract } from '@thirdweb-dev/react';
import Contracts from '@steerprotocol/contracts/deployments/mode.json';
import ContractsBase from '@steerprotocol/contracts/deployments/base.json';
import { useAsync } from 'react-use';
import { BigNumber } from 'ethers';
import { useSupportedChain } from '@app/hooks/other/useSupportedChain';
import { Base } from '@thirdweb-dev/chains';

export type VaultDetails = {
  decimals: BigNumber;
  name: string;
  symbol: string;
  token0: string;
  token0Balance: BigNumber;
  token0Decimals: BigNumber;
  token0Name: string;
  token0Symbol: string;
  token1: string;
  token1Balance: BigNumber;
  token1Decimals: BigNumber;
  token1Name: String;
  token1Symbol: string;
  totalLPTokensIssued: BigNumber;
  vaultCreator: Address;
  vaultType: 'MultiPositionKim';
};

export function useVaultDetailsByAddress(
  vaultAddress: Address | undefined | null
): {
  data: VaultDetails | undefined;
  isLoading: boolean;
} {
  const chainId = useSupportedChain()?.chainId;

  const { contract } = useContract(
    chainId === Base.chainId
      ? ContractsBase.contracts.SteerPeriphery.address
      : Contracts.contracts.SteerPeriphery.address,
    chainId === Base.chainId
      ? ContractsBase.contracts.SteerPeriphery_Implementation.abi
      : Contracts.contracts.SteerPeriphery.abi
  );

  const { value, loading } = useAsync(async () => {
    if (!contract || !vaultAddress) {
      return;
    }

    try {
      const res = await contract.call('algebraVaultDetailsByAddress', [
        vaultAddress
      ]);

      return res;
    } catch (e) {
      console.error(e);
    }
  }, [contract, vaultAddress]);

  return {
    data: value,
    isLoading: loading
  };
}
